import React from 'react';
import { Switch } from 'react-router';
import PrivateRoute from '../../components/PrivateRoute';
import CurricularEquivalenceForm from './curricular/CurricularEquivalenceForm.js';
import CurricularEquivalenceListPage from './curricular/CurricularEquivalenceListPage.js';

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/equivalencias/curricular/new"
      component={CurricularEquivalenceForm}
    />
    <PrivateRoute
      exact
      path="/equivalencias/curricular/:id/edit"
      component={CurricularEquivalenceForm}
    />
    <PrivateRoute
      exact
      path="/equivalencias/curricular"
      component={CurricularEquivalenceListPage}
    />
  </Switch>
);
